/**
 * @generated SignedSource<<4c1cb54bf74eb6083f7a24ac68efae75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PagerDutyIntegration_integration$data = {
  readonly credentials: any;
  readonly id: any;
  readonly integrationType: IntegrationType;
  readonly name: string;
  readonly " $fragmentType": "PagerDutyIntegration_integration";
};
export type PagerDutyIntegration_integration$key = {
  readonly " $data"?: PagerDutyIntegration_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"PagerDutyIntegration_integration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PagerDutyIntegration_integration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credentials",
      "storageKey": null
    }
  ],
  "type": "GraphQLIntegration",
  "abstractKey": null
};

(node as any).hash = "5dc370097978c2c9d15ad6c36ae324aa";

export default node;
